var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mt-3",attrs:{"id":"newPolicy"}},[_c('div',{staticClass:"container-fluid form-container",attrs:{"id":"newPolicy-container"}},[_c('policy-form',{ref:"policyFormChild",attrs:{"formConfigType":_vm.formConfigType,"readOnly":false,"anchorsOffset":72,"id":"newPolicy-policyForm"},on:{"form-submit":_vm.onFormSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc07eb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/NewPolicy.vue
// module id = T2Ai
// module chunks = 1